(() => {
  function init(root) {
    const form = root.querySelector('#GWGearDemoForm');
    if (!form || form.dataset.gwReady) return;
    form.dataset.gwReady = 'true';
    const key = 'gw-gear-demo-draft';
    const success = form.querySelector('[data-demo-success]');
    const error = form.querySelector('[data-demo-error]');
    if (success) {
      try { sessionStorage.removeItem(key); } catch (_) {}
      success.focus();
      return;
    }
    let savedProduct = '';
    if (error) {
      try {
        const draft = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (draft && Date.now() - draft.saved < 30 * 60 * 1000) {
          savedProduct = draft.product || '';
          for (const [name, value] of Object.entries(draft.fields)) {
            const field = [...form.elements].find((item) => item.name === name);
            if (field && field.type !== 'hidden' && (!field.value || field.tagName === 'SELECT')) field.value = value;
          }
        } else { sessionStorage.removeItem(key); }
      } catch (_) {}
      if (form.querySelector('#GWGearDemoBody')?.value) form.querySelector('[data-demo-extras]').open = true;
      error.focus();
    }
    const params = new URLSearchParams(location.search);
    const raw = params.get('product') || savedProduct;
    if (raw) {
      try {
        const url = new URL(raw, location.origin);
        if (url.origin === location.origin && /^\/products\/[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname)) {
          const canonical = url.origin + url.pathname;
          form.querySelector('[data-demo-product-field]').value = canonical;
          const box = form.querySelector('[data-demo-product]');
          const title = (params.get('product_title') || 'Selected product').slice(0, 160);
          const link = document.createElement('a');
          link.href = canonical;
          link.textContent = title;
          box.append('Selected gear: ', link);
          const models = form.querySelector('#GWGearDemoModels');
          if (!models.value) models.value = params.get('product_title') ? title : canonical;
          box.hidden = false;
        }
      } catch (_) {}
    }
    const parts = new Intl.DateTimeFormat('en-GB', {timeZone:'Australia/Brisbane', year:'numeric', month:'2-digit', day:'2-digit'}).formatToParts(new Date());
    const part = (type) => parts.find((item) => item.type === type).value;
    const today = `${part('year')}-${part('month')}-${part('day')}`;
    const minDate = new Date(today + 'T12:00:00Z');
    let days = Number(root.dataset.leadDays) || 2;
    while (days > 0) {
      minDate.setUTCDate(minDate.getUTCDate() + 1);
      if (![0, 6].includes(minDate.getUTCDay())) days--;
    }
    const earliest = minDate.toISOString().slice(0, 10);
    for (const id of ['GWGearDemoDate','GWGearDemoAltDate']) {
      const field = form.querySelector('#' + id);
      if (field) field.min = earliest;
    }
    function validateDate(field) {
      if (!field) return;
      let message = '';
      if (field.value) {
        const day = new Date(field.value + 'T12:00:00Z').getUTCDay();
        if (day === 0) message = 'Please choose Monday to Saturday.';
        else if (field.value < earliest) message = 'Please choose a date after the requested business-day notice period.';
      }
      field.setCustomValidity(message);
    }
    const dateFields = ['GWGearDemoDate', 'GWGearDemoAltDate'].map((id) => form.querySelector('#' + id)).filter(Boolean);
    for (const field of dateFields) {
      validateDate(field);
      field.addEventListener('input', () => validateDate(field));
      field.addEventListener('change', () => validateDate(field));
    }
    form.addEventListener('submit', (event) => {
      dateFields.forEach(validateDate);
      if (!form.reportValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      try {
        const fields = {};
        for (const item of form.elements) if (item.name && item.name.startsWith('contact[') && item.type !== 'hidden') fields[item.name] = item.value;
        sessionStorage.setItem(key, JSON.stringify({saved:Date.now(), fields, product:form.querySelector('[data-demo-product-field]').value}));
      } catch (_) {}
      const button = form.querySelector('[data-demo-submit]');
      if (button) { button.disabled = true; button.textContent = 'Sending request…'; }
    }, { capture: true });
  }
  document.querySelectorAll('[data-gw-demo]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-gw-demo]').forEach(init));
})();
